import { IAnesthesiaLineItemDTO } from './AnesthesiaLineItemDTO'
import { IPhysicalTherapyLineItemDTO } from './PhysicalTherapyLineItemDTO'
import { IProfessionalComponentLineItemDTO } from './ProfessionalComponentLineItemDTO'
import { ITechnicalComponentLineItemDTO } from './TechnicalComponentLineItemDTO'
import { IMiscellaneousLineItemDTO } from './MiscellaneousLineItemDTO'
import { DocumentButtonSummaryResult } from './DocumentButtonSummaryResult'
import { ButtonLabelSummaryResult } from './ButtonLabelSummaryResult'

export interface IQuoteDTO {
  id?: string
  groupNumber?: number
  preCertNumber?: string
  patientName?: string
  surgeryDate?: Date
  endDate?: Date
  bundleDurationDays?: number
  startDate?: Date
  dateOfBirth?: Date
  bodyPartName?: string
  episodeOfCareId?: string
  episodeOfCareNumber?: number
  patientId?: string
  patientIdNumber?: string
  status?: number
  type?: number
  note?: string
  targetMargin?: number
  targetReconciledMargin?: number
  adjustedCost?: number
  adjustedReconciledCost?: number
  isAdjustedCostOverridden?: boolean
  isAdjustedReconciledCostOverridden?: boolean
  adjustedCostOverriddenBy?: string
  adjustedCostOverriddenOn?: Date
  physicalTherapyLineItems?: IPhysicalTherapyLineItemDTO[]
  professionalComponentLineItems?: IProfessionalComponentLineItemDTO[]
  anesthesiaLineItems?: IAnesthesiaLineItemDTO[]
  technicalComponentLineItems?: ITechnicalComponentLineItemDTO[]
  miscellaneousLineItems?: IMiscellaneousLineItemDTO[]
  latestStatusComment?: string
  summarizedPCInvoiceLineItems?: IProfessionalComponentLineItemDTO[]
  summarizedTCInvoiceLineItems?: ITechnicalComponentLineItemDTO[]
  summarizedANInvoiceLineItems?: IAnesthesiaLineItemDTO[]
  summarizedPTInvoiceLineItems?: IPhysicalTherapyLineItemDTO[]
  claimButtons?: DocumentButtonSummaryResult[]
  claimButtonsPC?: DocumentButtonSummaryResult[]
  claimButtonsTC?: DocumentButtonSummaryResult[]
  claimButtonsPT?: DocumentButtonSummaryResult[]
  claimButtonsMI?: DocumentButtonSummaryResult[]
  claimButtonsAN?: DocumentButtonSummaryResult[]
  claimButtonsPTTotals?: ButtonLabelSummaryResult[]
  claimButtonsTCTotals?: ButtonLabelSummaryResult[]
  claimButtonsPCTotals?: ButtonLabelSummaryResult[]
  claimButtonsMITotals?: ButtonLabelSummaryResult[]
  claimButtonsANTotals?: ButtonLabelSummaryResult[]
  dxCodes?: string
  globalInvoiceId?: string
  initialInvoicePrintDate?: Date
  invoiceRegeneratedAfterPrint?: boolean
  episodeOfCareOrLegacyId?: string
  referralId?: string
  takeoverOfCareDate?: Date
  isNoPtToBeScheduled: boolean
  isConsumer?: boolean
  hasBeenConsumed?: boolean
  eocUnbundledClaims?: number
  episodeOfCareStatus?: string
  episodeOfCareCoordinationStatus?: string
}

export class QuoteDTO implements IQuoteDTO {
  public id?: string
  public groupNumber?: number
  public preCertNumber?: string
  public patientName?: string
  public surgeryDate?: Date
  public startDate?: Date
  public endDate?: Date
  public bundleDurationDays?: number
  public dateOfBirth?: Date
  public bodyPartName?: string
  public episodeOfCareId?: string
  public episodeOfCareNumber?: number
  public patientId?: string
  public patientIdNumber?: string
  public status?: number
  public type?: number
  public note?: string
  public targetMargin?: number
  public targetReconciledMargin?: number
  public adjustedCost?: number
  public adjustedReconciledCost?: number
  public isAdjustedCostOverridden?: boolean
  public isAdjustedReconciledCostOverridden?: boolean
  public adjustedCostOverriddenBy?: string
  public adjustedCostOverriddenOn?: Date
  public physicalTherapyLineItems?: IPhysicalTherapyLineItemDTO[]
  public professionalComponentLineItems?: IProfessionalComponentLineItemDTO[]
  public anesthesiaLineItems?: IAnesthesiaLineItemDTO[]
  public technicalComponentLineItems?: ITechnicalComponentLineItemDTO[]
  public miscellaneousLineItems?: IMiscellaneousLineItemDTO[]
  public latestStatusComment?: string
  public summarizedPCInvoiceLineItems?: IProfessionalComponentLineItemDTO[]
  public summarizedTCInvoiceLineItems?: ITechnicalComponentLineItemDTO[]
  public summarizedANInvoiceLineItems?: IAnesthesiaLineItemDTO[]
  public summarizedPTInvoiceLineItems?: IPhysicalTherapyLineItemDTO[]
  public claimButtons?: DocumentButtonSummaryResult[]
  public claimButtonsPC?: DocumentButtonSummaryResult[]
  public claimButtonsTC?: DocumentButtonSummaryResult[]
  public claimButtonsPT?: DocumentButtonSummaryResult[]
  public claimButtonsMI?: DocumentButtonSummaryResult[]
  public claimButtonsAN?: DocumentButtonSummaryResult[]
  public dxCodes?: string
  public globalInvoiceId?: string
  public initialInvoicePrintDate?: Date
  public invoiceRegeneratedAfterPrint?: boolean
  public episodeOfCareOrLegacyId?: string
  public referralId?: string
  public takeoverOfCareDate?: Date
  public isNoPtToBeScheduled: boolean = false
  public isConsumer?: boolean
  public hasBeenConsumed?: boolean
  public eocUnbundledClaims?: number
  public episodeOfCareStatus?: string
  public episodeOfCareCoordinationStatus?: string
  constructor(
    note: string,
    isAdjustedCostOverridden: boolean,
    targetMargin?: number,
    adjustedCost?: number,
    targetReconciledMargin?: number,
    adjustedReconciledCost?: number,
    adjustedCostOverriddenBy?: string,
    adjustedCostOverriddenOn?: Date,
    physicalTherapyLineItems?: IPhysicalTherapyLineItemDTO[],
    professionalComponentLineItems?: IProfessionalComponentLineItemDTO[],
    anesthesiaLineItems?: IAnesthesiaLineItemDTO[],
    technicalComponentLineItems?: ITechnicalComponentLineItemDTO[],
    miscellaneousLineItems?: IMiscellaneousLineItemDTO[],
    claimButtons?: DocumentButtonSummaryResult[],
    dxCodes?: string,
    globalInvoiceId?: string,
    initialInvoicePrintDate?: Date,
    invoiceRegeneratedAfterPrint?: boolean,
    episodeOfCareOrLegacyId?: string,
    endDate?: Date,
    bundleDurationDays?: number,
    startDate?: Date
  ) {
    this.note = note
    this.targetMargin = targetMargin
    this.targetReconciledMargin = targetReconciledMargin
    this.adjustedCost = adjustedCost
    this.adjustedReconciledCost = adjustedReconciledCost
    this.isAdjustedCostOverridden = isAdjustedCostOverridden
    this.adjustedCostOverriddenBy = adjustedCostOverriddenBy
    this.adjustedCostOverriddenOn = adjustedCostOverriddenOn
    this.physicalTherapyLineItems = physicalTherapyLineItems
    this.professionalComponentLineItems = professionalComponentLineItems
    this.anesthesiaLineItems = anesthesiaLineItems
    this.technicalComponentLineItems = technicalComponentLineItems
    this.miscellaneousLineItems = miscellaneousLineItems
    this.claimButtons = claimButtons
    this.dxCodes = dxCodes
    this.globalInvoiceId = globalInvoiceId
    this.initialInvoicePrintDate = initialInvoicePrintDate
    this.invoiceRegeneratedAfterPrint = invoiceRegeneratedAfterPrint
    this.episodeOfCareOrLegacyId = episodeOfCareOrLegacyId
    this.endDate = endDate
    this.bundleDurationDays = bundleDurationDays
    this.startDate = startDate
  }
}
